export const NOTIFICATIONS = {
  NOTIFICATION_CENTER: 'NOTIFICATION_CENTER',
  PUSH_PERMISSION: 'PUSH_PERMISSION',
};
